import { Component, type ErrorInfo, type ReactNode } from "react";
import { Hata500 } from "./SistemSayfalari";

interface Durum {
  hata: Error | null;
}

/**
 * HATA SINIRI — 04.09.2026
 *
 * ================================================================
 * DEPODA HİÇ YOKTU
 * ================================================================
 * Bir bileşen render sırasında patlarsa React bütün ağacı söküyor
 * ve kullanıcı **beyaz bir sayfa** görüyordu. Ne olduğu, ne
 * yapılacağı, hatta uygulamanın çalışıp çalışmadığı belli olmuyordu.
 *
 * Bu, sunucu hatasından daha kötü bir durumdu: sunucu hatası hiç
 * olmazsa bir mesaj döndürüyor.
 *
 * ================================================================
 * SINIF BİLEŞENİ — SEÇİM DEĞİL, ZORUNLULUK
 * ================================================================
 * Depodaki tek sınıf bileşeni bu ve öyle olmak zorunda:
 * `componentDidCatch` ve `getDerivedStateFromError` kancalarla
 * yazılamıyor. React 19'da da durum aynı.
 *
 * ================================================================
 * KÖK DEĞİL, İÇERİK ETRAFINDA
 * ================================================================
 * Sınır kabuğun İÇİNE konuluyor: menü ve üst bant ayakta kalıyor,
 * yalnızca patlayan ekran yerine hata sayfası çiziliyor. Kökü
 * sarsaydık, tek bir ekranın hatası bütün paneli kullanılamaz
 * hâle getirirdi.
 *
 * ================================================================
 * `resetKey` DEĞİŞİNCE KENDİNİ TOPLUYOR
 * ================================================================
 * Ekran değiştirildiğinde sınır sıfırlanıyor. Sıfırlanmasaydı, bir
 * ekranda alınan hata bütün gezinmeyi kilitler ve kullanıcı
 * sayfayı yenilemek zorunda kalırdı.
 */
export class HataSiniri extends Component<
  { children: ReactNode; resetKey?: string | number },
  Durum
> {
  override state: Durum = { hata: null };

  static getDerivedStateFromError(hata: Error): Durum {
    return { hata };
  }

  override componentDidCatch(hata: Error, bilgi: ErrorInfo): void {
    /*
      SUNUCUYA GÖNDERİLMİYOR — bilerek.

      Bir hata bildirimi ucu yok ve uydurmak yanlış olurdu: gönderilen
      yığın izi içinde ekranda duran kişisel veri bulunabilir
      (öğrenci adı, not içeriği) ve o veri bir kayda düşerdi.
      F-LOG-14 istisna metnini saklamayı ama içindeki kişisel veriyi
      temizlemeyi şart koşuyor; temizleyici yazılmadan göndermek o
      şartı ihlal ederdi.

      `console.error` CLAUDE.md'nin izin verdiği tek çıktı ve burada
      doğru yer: tarayıcı konsolu geliştiricinin gördüğü yer.
    */
    console.error("Arayüz hatası:", hata, bilgi.componentStack);
  }

  override componentDidUpdate(oncekiProps: { resetKey?: string | number }): void {
    if (this.state.hata !== null && oncekiProps.resetKey !== this.props.resetKey) {
      this.setState({ hata: null });
    }
  }

  override render(): ReactNode {
    if (this.state.hata !== null) {
      return <Hata500 onYenile={() => this.setState({ hata: null })} />;
    }
    return this.props.children;
  }
}
